import React from "react";

import { css } from "@emotion/css";
import BG from "../../../img/png/home/how-it-works/bg-grid.png";
import Clothes from "../../../img/png/home/how-it-works/clothes.png";
import Icons from "../../../img/png/home/how-it-works/icons.png";
import Arrow from "../../../img/svg/home/how-it-works/arrow.svg";
import Logo from "../../../img/png/home/how-it-works/logo.png";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import { useI18n } from "../../../i18n";

const HowItWorks = () => {
  const { t } = useI18n();
  return (
  <div
    style={{ position: "relative", background: "#F6F4F2", overflow: "hidden" }}
  >
    <div className={style.title}>
      <div className="wrapper">
        <h2 className="how">{t("home_how_how")}</h2>
        <img src={Arrow} className="arrow" alt={t("home_how_alt_arrow")} />
        <h2 className="does">{t("home_how_does")}</h2>
        <img src={Clothes} className="clothes" alt={t("home_how_alt_clothes")} />
        <h2 className="work">{t("home_how_work")}</h2>
        <span className="zilouet-wrapper">
          <img src={Icons} className="icons" alt={t("home_how_alt_icons")} />
          <img src={Logo} className="logo" alt={t("home_how_alt_zilouet")} />
        </span>
      </div>
    </div>
  </div>
  );
};

const style = {
  title: css({
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    backgroundImage: `url(${BG})`,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: 80,
    marginBottom: 120,

    h2: {
      color: "#000",
      fontFamily: "Syne",
      fontSize: 118,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "99.585%",
    },

    ".wrapper": {
      maxWidth: 1100,
      width: "100%",
      position: "relative",
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      alignContent: "center",
      gap: 20,

      ".arrow": {
        width: 177,
        height: "auto",
      },
      ".clothes": {
        width: 290,
        height: "auto",
        borderRadius: 100,
      },
      ".zilouet-wrapper": {
        position: "relative",

        ".icons": {
          width: 170,
          height: "auto",
        },
        ".logo": {
          width: 280,
          height: "auto",
          position: "absolute",
          left: "-70%",
          top: "75%",
        },
      },
    },
    [desktop]: {
      h2: {
        fontSize: 95,
        lineHeight: "94%",
      },

      ".wrapper": {
        maxWidth: 900,

        ".arrow": {
          width: 157,
        },
        ".clothes": {
          width: 270,
          height: "auto",
          borderRadius: 100,
        },
        ".zilouet-wrapper": {

          ".icons": {
            width: 150,
          },
          ".logo": {
            width: 260,
            left: "-75%",
          },
        },
      },
    },
    [laptop]: {
      marginTop: 40,
      marginBottom: 100,
      h2: {
        fontSize: 90,
        lineHeight: "72%",
      },

      ".wrapper": {
        maxWidth: 565,

        ".how": {
          order: 1
        },
        ".arrow": {
          order: 2,
          width: 137,
        },
        ".clothes": {
          width: 250,
          height: "auto",
          borderRadius: 100,
          order: 3
        },
        ".does": {
          order: 4
        },
        ".work": {
          order: 5
        },
        ".zilouet-wrapper": {
          order: 6,

          ".icons": {
            width: 130,
          },
          ".logo": {
            width: 240,
            left: "-80%",
          },
        },
      },
    },
    [tablet]: {
      marginTop: 0,
      marginBottom: 80,
      h2: {
        fontSize: 46,
        lineHeight: "79%",
      },

      ".wrapper": {
        maxWidth: 365,
        gap: 10,

        ".arrow": {
          order: 2,
          width: 80,
        },
        ".clothes": {
          width: 160,
          height: "auto",
          borderRadius: 100,
          order: 3
        },
        ".zilouet-wrapper": {
          order: 6,

          ".icons": {
            width: 100,
          },
          ".logo": {
            width: 200,
            left: "-80%",
          },
        },
      },
    },
  }),
};

export default HowItWorks;
